import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useCrmPermissions } from "@/hooks/use-crm-access";

export const Route = createFileRoute("/crm/")({
	component: CrmIndex,
});

/** The CRM's entry page: the pipeline for sales, contacts for support (read-only). */
function CrmIndex(): ReactElement {
	const { canManage } = useCrmPermissions();
	return (
		<Navigate to={canManage ? "/crm/opportunities" : "/crm/contacts"} replace />
	);
}
